/* raw-ok: SVG grid/stroke spec in prose, not a CSS literal — 24-unit grid, currentColor stroke,
 * the same house convention as battle/elementIcons.tsx. */
import type { SlotGroupCode } from './slotGroups';

// One glyph per category, distinct SHAPE (§11.8 "never colour alone" — every plate also carries a
// visible text label, SlotRail.tsx). No raster art order: the standing directive is that the art
// agent fills images later, and a five-glyph set that has to read at --sp-7 is better drawn as
// strokes anyway.
const PATHS: Record<SlotGroupCode, string> = {
  // a cap: dome + brim
  head: 'M5 14a7 7 0 0 1 14 0M3 14h18M6 14v3h12v-3',
  // a tunic: shoulders + hem
  body: 'M8 4l4 2 4-2 4 4-3 2v10H7V10L4 8z',
  // a paw: pad + three toes
  paws: 'M12 13a4 3 0 1 0 0 6 4 3 0 1 0 0-6zM7 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3zM12 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3zM17 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3z',
  // a wing: two swept strokes
  back: 'M4 16c3-8 9-11 16-10-2 3-3 6-3 9-4-1-8 0-13 1zM4 16l5-3',
  // a framed scene: frame + horizon + sun
  scene: 'M3 5h18v14H3zM3 15l5-4 4 3 4-5 5 4M16 9a1.5 1.5 0 1 0 0 .01',
};

/** Inline glyph for a wardrobe category plate. `aria-hidden`: the plate's own visible label and
 *  accessible name carry the meaning; the glyph is the fast visual cue beside them. */
export function GroupGlyph({ code, className }: { code: SlotGroupCode; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" focusable="false"
      fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d={PATHS[code]} />
    </svg>
  );
}
